module.exports = __webpack_public_path__ + "img/8dys-01.5426738e.png";